


// import { useState, useEffect } from "react";

// const Footer = () => {
//   const [footerData, setFooterData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showScrollTop, setShowScrollTop] = useState(false);

//   // Scroll to top
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   // Show scroll-to-top button
//   useEffect(() => {
//     const handleScroll = () => {
//       setShowScrollTop(window.scrollY > 300);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Fetch footer data
//   useEffect(() => {
//     const fetchFooterData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/footer-section");
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//         const result = await response.json();
//         if (result.success && result.data) {
//           setFooterData(result.data);
//         } else {
//           throw new Error(result.message || "Failed to fetch footer data");
//         }
//       } catch (err) {
//         console.error("Error fetching footer data:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchFooterData();
//   }, []);

//   if (loading) return <div className="text-center py-8">Loading footer...</div>;
//   if (error) return <div className="text-center py-8 text-red-500">Error: {error}</div>;
//   if (!footerData || !footerData.isActive) return null;

//   const { topSection, middleSection, bottomSection } = footerData;

//   return (
//     // <>
//     //   <footer className="main-footer pt-80">
//     //     <div className="container">
//     //       <div className="row justify-content-xl-between justify-content-center">
//     //         {/* ===== About Section ===== */}
//     //         <div className="col-xl-4 col-lg-5 col-md-6">
//     //           <div className="footer-widget widget_about me-md-5 wow fadeInUp delay-0-2s">
//     //             <div className="footer-logo mb-25">
//     //               <a href="/">
//     //                 <img
//     //                   src={middleSection?.logoUrl || "assets/images/logos/logo-three.png"}
//     //                   alt="Logo"
//     //                 />
//     //               </a>
//     //             </div>
//     //             <p>{middleSection?.description || "Default footer description text"}</p>

//     //             {/* Social Links */}
//     //             <div className="social-style-two pt-5">
//     //               {topSection?.socialLinks?.map(
//     //                 (link, index) =>
//     //                   link.isActive && (
//     //                     <a
//     //                       href={link.url}
//     //                       key={index}
//     //                       target="_blank"
//     //                       rel="noopener noreferrer"
//     //                     >
//     //                       <i className={`fab fa-${link.platform}`} />
//     //                     </a>
//     //                   )
//     //               )}
//     //             </div>
//     //           </div>
//     //         </div>

//     //         {/* ===== Quick Links ===== */}
//     //         <div className="col-xl-4 col-md-6">
//     //           <div className="footer-widget widget_nav_menu wow fadeInUp delay-0-4s">
//     //             {/* <h4 className="footer-title">
//     //               {middleSection?.quickLinksTitle || "Quick Links"}
//     //             </h4> */}
//     //             <ul className="list-style-two">
//     //               {middleSection?.quickLinks?.map(
//     //                 (link, index) =>
//     //                   link.isActive && (
//     //                     <li key={index}>
//     //                       <a href={link.url}>{link.text}</a>
//     //                     </li>
//     //                   )
//     //               )}
//     //             </ul>
//     //           </div>
//     //         </div>

//     //         {/* ===== Contact Info ===== */}
//     //         <div className="col-xl-4 col-lg-6 col-md-8">
//     //           <div className="footer-widget widget_newsletter wow fadeInUp delay-0-6s">
//     //             <h4 className="footer-title">
//     //               {middleSection?.contactTitle || "Address"}
//     //             </h4>
//     //             {middleSection?.contactInfo?.phone && (
//     //               <p>Phone: {middleSection.contactInfo.phone}</p>
//     //             )}
//     //             {middleSection?.contactInfo?.email && (
//     //               <p>Email: {middleSection.contactInfo.email}</p>
//     //             )}
//     //             {middleSection?.contactInfo?.address && (
//     //               <p>Address: {middleSection.contactInfo.address}</p>
//     //             )}
//     //           </div>
//     //         </div>
//     //       </div>
//     //     </div>

//     //     {/* ===== Footer Bottom ===== */}
//     //     <div className="footer-bottom mt-30 pt-25 pb-10">
//     //       <div className="container">
//     //         <div className="row align-items-center">
//     //           <div className="col-lg-12">
//     //             <div className="copyright-text text-center">
//     //               <p>
//     //                 {bottomSection?.copyrightText ||
//     //                   "© Copyright 2025. All rights reserved."}
//     //               </p>
//     //             </div>
//     //           </div>
//     //         </div>

//     //         {/* ===== Scroll To Top ===== */}
//     //         {showScrollTop && (
//     //           <button
//     //             onClick={scrollToTop}
//     //             className="scroll-to-top"
//     //             style={{
//     //               position: "fixed",
//     //               bottom: "30px",
//     //               right: "30px",
//     //               backgroundColor: "#000",
//     //               color: "#fff",
//     //               padding: "10px 15px",
//     //               borderRadius: "50%",
//     //               border: "none",
//     //               cursor: "pointer",
//     //               zIndex: 9999,
//     //             }}
//     //           >
//     //             <i className="fas fa-angle-double-up"></i>
//     //           </button>
//     //         )}
//     //       </div>
//     //     </div>
//     //   </footer>
//     // </>

//     <> <div>
//   <footer className="cs_footer cs_style_1 cs_type_3">
//     <div className="cs_height_130 cs_height_lg_80" />
//     <div className="container">
//       <div className="cs_footer_main">
//         <div className="row cs_gap_y_30">
//           <div className="col-xl-5 col-lg-4 col-md-7">
//             <div className="cs_footer_widget cs_text_widget">
//               <div className="cs_brand cs_mb_10 wow fadeInUp">
//                 <img src="assets/img/logo.svg" alt="Logo" />
//               </div>
//               <p className="mb-0">Our analytics application turns raw data into actionable insights, empowering businesses to make data-driven decisions and enhance performance.</p>
//             </div>
//           </div>
//           <div className="col-xl-2 col-lg-2 col-md-4 offset-lg-0 offset-md-1">
//             <div className="cs_footer_widget cs_links_widget">
//               <h3 className="cs_footer_widget_title cs_fs_21 cs_mb_21">Quick Links</h3>
//               <ul className="cs_footer_medu cs_mp_0">
//                 <li><a href="index.html" aria-label="Home page link">Home</a></li>
//                 <li><a href="features.html" aria-label="Features page link">Features</a></li>
//                 <li><a href="pricing.html" aria-label="Pricing page link">Pricing</a></li>
//                 <li><a href="blog.html" aria-label="Blog page link">Blog</a></li>
//                 <li><a href="contact.html" aria-label="Contact page link">Contact</a></li>
//               </ul>
//             </div>
//           </div>
//           <div className="col-xl-2 col-lg-3 col-md-7">
//             <div className="cs_footer_widget cs_help_widget">
              
             
//             </div>
//           </div>
//           <div className="col-xl-3 col-lg-3  col-md-4 offset-md-1 offset-lg-0">
//             <div className="cs_footer_widget cs_contact_widget">
//               <h3 className="cs_footer_widget_title cs_fs_21 cs_mb_21">Contact Info</h3>
//               <ul className="cs_footer_medu cs_mp_0">
//                 <li>24/7 Support Center</li>
//                 <li><a href="mailto:contact@gosaas.com" aria-label="Email send link">contact@gosaas.com </a></li>
//                 <li><a href="tel:55123456789" aria-label="Phone call link">(55) 1234-56789</a></li>
               
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="cs_height_62 cs_height_lg_40" />
//       <div className="cs_footer_bottom">
//         <div className="cs_social_links cs_style_1 cs_heading_color">
//           <a href="#" aria-label="Social link">
//             <span className="cs_social_icon cs_purple_color"><i className="fa-brands fa-facebook" /></span>
//             <span>Facebook</span>
//           </a>
//           <a href="#" aria-label="Social link">
//             <span className="cs_social_icon cs_purple_color"><i className="fa-brands fa-youtube" /></span>
//             <span>YouTube</span>
//           </a>
//           <a href="#" aria-label="Social link">
//             <span className="cs_social_icon cs_purple_color"><i className="fa-brands fa-square-instagram" /></span>
//             <span>Instagram</span>
//           </a>
//         </div>
//         <div className="cs_footer_text cs_heading_color">Copyright © <span className="cs_getting_year" /> GoSaas theme by Laralink</div>
//       </div>
//     </div>
//   </footer>
//   {/* End Footer Section */}
//   {/* Start Scroll Up Button */}
//   <button type="button" aria-label="Scroll to top button" className="cs_scrollup cs_purple_bg cs_white_color cs_radius_100">
//     <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z" fill="currentColor" />
//     </svg>
//   </button>
// </div>
// </>
//   );
// };

// export default Footer;


import { useState, useEffect } from "react";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Show scroll-to-top button
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch footer data
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        setLoading(true);
        const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/footer-section");
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        if (result.success && result.data) {
          setFooterData(result.data);
        } else {
          throw new Error(result.message || "Failed to fetch footer data");
        }
      } catch (err) {
        console.error("Error fetching footer data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchFooterData();
  }, []);

  if (loading) return <div className="text-center py-8">Loading footer...</div>;
  if (error) return <div className="text-center py-8 text-red-500">Error: {error}</div>;
  if (!footerData || !footerData.isActive) return null;

  const { topSection, middleSection, bottomSection } = footerData;

  return (
    <>
      <div>
        <footer className="cs_footer cs_style_1 cs_type_3">
          <div className="cs_height_130 cs_height_lg_80" />
          <div className="container">
            <div className="cs_footer_main">
              <div className="row cs_gap_y_30">
                {/* ===== About Section ===== */}
                <div className="col-xl-5 col-lg-4 col-md-7">
                  <div className="cs_footer_widget cs_text_widget">
                    <div className="cs_brand cs_mb_10 wow fadeInUp">
                      <img
                        src={middleSection?.logoUrl || "assets/img/logo.svg"}
                        alt="Logo"
                      />
                    </div>
                    <p className="mb-0">
                      {middleSection?.description ||
                        "Our analytics application turns raw data into actionable insights, empowering businesses to make data-driven decisions and enhance performance."}
                    </p>
                  </div>
                </div>

                {/* ===== Quick Links ===== */}
                <div className="col-xl-3 col-lg-2 col-md-4 offset-lg-0 offset-md-1">
                  <div className="cs_footer_widget cs_links_widget">
                    {/* <h3 className="cs_footer_widget_title cs_fs_21 cs_mb_21">
                      {middleSection?.quickLinksTitle || "Quick Links"}
                    </h3> */}
                    {/* <ul className="cs_footer_medu cs_mp_0">
                      {middleSection?.quickLinks?.map(
                        (link, index) =>
                          link.isActive && (
                            <li key={index}>
                              <a href={link.url} aria-label={`${link.text} page link`}>
                                {link.text}
                              </a>
                            </li>
                          )
                      )}
                    </ul> */}
                  </div>
                </div>

                {/* ===== Contact Info ===== */}
                <div className="col-xl-4 col-lg-3 col-md-4 offset-md-1 offset-lg-0">
                  <div className="cs_footer_widget cs_contact_widget">
                    <h3 className="cs_footer_widget_title cs_fs_21 cs_mb_21">
                      {middleSection?.contactTitle || "Contact Info"}
                    </h3>
                    <ul className="cs_footer_medu cs_mp_0">
                      {middleSection?.contactInfo?.support && (
                        <li>{middleSection.contactInfo.support}</li>
                      )}
                      {middleSection?.contactInfo?.email && (
                        <li>
                          <a
                            href={`mailto:${middleSection.contactInfo.email}`}
                            aria-label="Email link"
                          >
                            {middleSection.contactInfo.email}
                          </a>
                        </li>
                      )}
                      {middleSection?.contactInfo?.phone && (
                        <li>
                          <a
                            href={`tel:${middleSection.contactInfo.phone}`}
                            aria-label="Phone link"
                          >
                            {middleSection.contactInfo.phone}
                          </a>
                        </li>
                      )}

                       {middleSection?.contactInfo?.address && (
                        <li>{middleSection.contactInfo.address}</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="cs_height_62 cs_height_lg_40" />
            <div className="cs_footer_bottom">
              <div className="cs_social_links cs_style_1 cs_heading_color">
                {topSection?.socialLinks?.map(
                  (link, index) =>
                    link.isActive && (
                      <a
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${link.platform} social link`}
                      >
                        <span className="cs_social_icon cs_purple_color">
                          <i className={`fa-brands fa-${link.platform}`} />
                        </span>
                        <span>{link.platform}</span>
                      </a>
                    )
                )}
              </div>

              <div className="cs_footer_text cs_heading_color">
                {bottomSection?.copyrightText ||
                  "Copyright © 2025 GoSaas theme by Laralink"}
              </div>
            </div>
          </div>
        </footer>

        {/* Scroll to Top Button */}
        {showScrollTop && (
          <button
            type="button"
            aria-label="Scroll to top button"
            onClick={scrollToTop}
            className="cs_scrollup cs_purple_bg cs_white_color cs_radius_100"
          >
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
                fill="currentColor"
              />
            </svg>
          </button>
        )}
      </div>
    </>
  );
};

export default Footer;





